import Modal from '../ui/Modal';
import Button from '../ui/Button';
import EstadoActivoPill from './EstadoActivoPill';
import { formatDate } from '../../utils/formatters';

function VisualizarConceptoModal({ isOpen, onClose, item }) {
  if (!item) return null;

  const tipoAcronym = item.tipoConcepto?.tpConcepto ?? item.tpConcepto ?? '—';
  const tipoLabel = item.tipoConcepto?.deTipoConcepto ?? '—';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle del concepto"
      description="Información completa del registro"
      size="md"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      }
    >
      <dl className="divide-y divide-white/5 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]">
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Código
          </dt>
          <dd className="font-mono text-sm text-white/90">{item.cdConcepto}</dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Tipo de concepto
          </dt>
          <dd className="inline-flex items-center gap-2 text-right text-sm font-medium text-white/90">
            <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-md border border-white/10 bg-white/[0.04] px-1.5 font-mono text-[11px] uppercase tracking-wider text-white/65">
              {tipoAcronym}
            </span>
            {tipoLabel}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Concepto
          </dt>
          <dd className="text-right text-sm font-medium text-white/90">{item.deConcepto}</dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Fecha de registro
          </dt>
          <dd className="font-mono text-sm text-white/90">
            {formatDate(item.feRegistro)}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-4 px-4 py-3 sm:px-5">
          <dt className="text-[11px] font-mono uppercase tracking-[0.18em] text-white/45">
            Estatus
          </dt>
          <dd>
            <EstadoActivoPill status={item.stConcepto} />
          </dd>
        </div>
      </dl>
    </Modal>
  );
}

export default VisualizarConceptoModal;